(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/product-start-page/views/promos/no-open-draws.js') >= 0) return;  svs.modules.push('/components/app/product-start-page/views/promos/no-open-draws.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.app=_svs.app||{};
_svs.app.product_start_page=_svs.app.product_start_page||{};
_svs.app.product_start_page.templates=_svs.app.product_start_page.templates||{};
svs.app.product_start_page.templates.no_open_draws = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"promos-no-open-draws\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"noOpenDrawsText") || (depth0 != null ? lookupProperty(depth0,"noOpenDrawsText") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"noOpenDrawsText","hash":{},"data":data,"loc":{"start":{"line":1,"column":34},"end":{"line":1,"column":55}}}) : helper))) != null ? stack1 : "")
    + "</div>";
},"useData":true});
Handlebars.partials['components-app-product_start_page-no_open_draws'] = svs.app.product_start_page.templates.no_open_draws;
})(svs, Handlebars);


 })(window);